
function formatCurrency(cents) {
  const amount = cents / 100;
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function showToast(message) {
  const container = document.getElementById("toastContainer");
  if (!container) return;

  const toast = document.createElement("div");
  toast.className = "toast";


  toast.innerHTML = `
    <div class="toast-msg">${message}</div>
  `;

  container.prepend(toast);

  toast.offsetHeight;

  requestAnimationFrame(() => {
    toast.classList.add("active-toast");
    updateStack();
  });

  setTimeout(() => {
    toast.classList.remove("active-toast");

    toast.style.opacity = "0";
    toast.style.transform = "translateY(120px) scale(.9)";

    setTimeout(() => {
      toast.remove();
      updateStack();
    }, 500);
  }, 3000);
}

function updateStack() {
  const toasts = document.querySelectorAll(".toast");

  toasts.forEach((toast, index) => {
    if (!toast.classList.contains("active-toast")) return;
    if (index > 2) {
      toast.style.opacity = "0";
      return;
    }

    const scale = 1 - (index * 0.04);
    const y = index * 12;

    toast.style.zIndex = 100 - index;
    toast.style.opacity = 1 - (index * 0.15);
    toast.style.transform = `translateY(${y}px) scale(${scale})`;
  });
}
document.addEventListener("DOMContentLoaded", function () {

  function changeQty(val) {
    const qtyInput = document.getElementById("qtyVal");
    const maxStock = parseInt(document.getElementById("maxStock").value) || 1;

    let current = parseInt(qtyInput.value) || 1;
    let newQty = current + val;

    // MIN LIMIT
    if (newQty < 1) {
      newQty = 1;
      showToast("Minimum quantity is 1");
    }

    // MAX LIMIT
    if (newQty > maxStock) {
      newQty = maxStock;
      showToast("Maximum available quantity is " + maxStock);
    }

    qtyInput.value = newQty;
  }

  window.changeQty = changeQty;
  const qtyInput = document.getElementById("qtyVal");
  if (qtyInput) {
    qtyInput.addEventListener("input", function () {
      const maxStock = parseInt(document.getElementById("maxStock").value) || 1;
      this.value = this.value.replace(/[^0-9]/g, "");
      let value = parseInt(this.value);
      if (!this.value) return;

      // MIN LIMIT
      if (value < 1) {
        this.value = 1;
        showToast("Minimum quantity is 1");
        return;
      }
      if (value > maxStock) {
        this.value = maxStock;
        showToast("Maximum available quantity is " + maxStock);
        return;
      }
    });

    qtyInput.addEventListener("blur", function () {
      const maxStock = parseInt(document.getElementById("maxStock").value) || 1;
      let value = parseInt(this.value);

      if (!value || value < 1) {
        this.value = 1;
        showToast("Minimum quantity is 1");
        return;
      }

      if (value > maxStock) {
        this.value = maxStock;
        showToast("Only " + maxStock + " items available");
      }
    });

  }

});
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("submit", function (e) {
    const targetForm = e.target;

    if (targetForm.action && targetForm.action.includes("/cart/add")) {
      e.preventDefault();

      const btn = targetForm.querySelector(".kti-atc-btn");
      const globalLoader = document.getElementById("CartDrawerLoader");

      /* =========================================
         SAME ANIMATION AS SINGLE PRODUCT PAGE
         ========================================= */

      if (btn) {

        // Cart icon pop
        btn.classList.add("pop");

        setTimeout(() => {
          btn.classList.remove("pop");
        }, 250);

        // Morph to check
        setTimeout(() => {
          btn.classList.add("added");
        }, 150);

        // Return to normal
        setTimeout(() => {
          btn.classList.remove("added");
        }, 1600);
      }

      if (globalLoader) {
        globalLoader.classList.add("is-loading");
      }

      const formData = new FormData(targetForm);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Failed to add product");
          }

          return res.json();
        })
        .then(() => {

          showToast("Product added to cart");

          const cartRefreshEvent = new CustomEvent("cart:item-added");
          document.dispatchEvent(cartRefreshEvent);

        })
        .catch((err) => {

          console.error("Error adding item:", err);
          showToast("Error adding product");

          // If adding fails, return button to normal
          if (btn) {
            btn.classList.remove("pop");
            btn.classList.remove("added");
          }

        })
        .finally(() => {

          if (btn) {
            btn.disabled = false;
          }

          if (globalLoader) {
            globalLoader.classList.remove("is-loading");
          }

        });
    }
  });

});

function updateCartCount(count) {
  const el = document.getElementById("CartCount");
  if (!el) return;

  if (count > 0) {
    el.innerText = count;
    el.style.display = "flex";

    el.classList.add("bump");
    setTimeout(() => el.classList.remove("bump"), 300);

  } else {
    el.style.display = "none";
  }
}

(function () {
  'use strict';

  const mainImg = document.getElementById('ktiMainImg');
  const zoomModal = document.getElementById('ktiZoomModal');
  const zoomImg = document.getElementById('ktiZoomImg');
  const zoomClose = document.getElementById('ktiZoomClose');
  const thumbWrap = document.getElementById('ktiThumbs');
  // PRELOAD all gallery images into browser cache on page load
  if (thumbWrap) {
    thumbWrap.querySelectorAll('.kti-thumb').forEach(function (thumb) {
      const preloadImg = new Image();
      preloadImg.src = thumb.dataset.src;
    });
  }
  if (thumbWrap) {
    thumbWrap.addEventListener('click', function (e) {
      const btn = e.target.closest('.kti-thumb');
      if (!btn || btn.classList.contains('active')) return;

      thumbWrap.querySelectorAll('.kti-thumb').forEach((t) => t.classList.remove('active'));
      btn.classList.add('active');

      mainImg.classList.add('kti-fading');

      setTimeout(function () {
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt;
        mainImg.dataset.zoomsrc = btn.dataset.src;
        mainImg.classList.remove('kti-fading');
      }, 120);
    });
  }

  if (mainImg) {
    mainImg.addEventListener('click', function () {
      if (zoomImg && zoomModal) {
        zoomImg.src = mainImg.dataset.zoomsrc || mainImg.src;
        zoomImg.alt = mainImg.alt;
        zoomModal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  function closeZoom() {
    if (zoomModal) {
      zoomModal.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (zoomClose) zoomClose.addEventListener('click', closeZoom);
  if (zoomModal) {
    zoomModal.addEventListener('click', function (e) {
      if (e.target === zoomModal) closeZoom();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoom();
  });
})();

function toggleAcc(btn) {
  const item = btn.closest('.acc-item');
  const body = item.querySelector('.acc-body');
  const inner = item.querySelector('.acc-body-inner');
  const isOpen = item.classList.contains('open');

  document.querySelectorAll('.acc-item').forEach((i) => {
    i.classList.remove('open');
    const b = i.querySelector('.acc-body');
    if (b) b.style.maxHeight = '0';
  });

  if (!isOpen && item && body && inner) {
    item.classList.add('open');
    body.style.maxHeight = inner.scrollHeight + 'px';
  }
}

const overlay = document.getElementById('searchOverlay');
const closeBtn = document.getElementById('searchClose');

const searchIcon = document.querySelector('.search-trigger');

const searchInput = document.querySelector('#search-bar-hide input');
const headerBtn = document.getElementById("headerSearchBtn");

if (headerBtn) {
  headerBtn.addEventListener("click", () => {
    overlay.classList.add("active");
  });
}

searchIcon.addEventListener('click', (e) => {
  e.preventDefault();
  overlay.classList.add('active');
});

searchInput.addEventListener('focus', (e) => {
  e.preventDefault();
  overlay.classList.add('active');
});

closeBtn.addEventListener('click', () => {
  overlay.classList.remove('active');
  if (overlayInput) {
    overlayInput.value = "";
  }
});

overlay.addEventListener('click', (e) => {
  if (e.target === overlay) {
    overlay.classList.remove('active');
    if (overlayInput) {
      overlayInput.value = "";
    }
  }
});

const words = [
  "Copper Spoon",
  "Copper Thali",
  "Copper Water Jug",
  "Hammered Copper Glass",
  "Hammered Copper Bottle"
];

const headerInput = document.querySelector('#search-bar-hide input');
const overlayInput = document.getElementById('animatedSearch');

function startTyping(input) {
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let timer;

  function typeEffect() {
    const currentWord = words[wordIndex];

    charIndex = isDeleting ? charIndex - 1 : charIndex + 1;

    const text = currentWord.substring(0, charIndex);
    input.placeholder = `Search for "${text}"`;

    let speed = isDeleting ? 80 : 180;

    if (!isDeleting && charIndex === currentWord.length) {
      speed = 1200;
      isDeleting = true;
    }
    else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      speed = 300;
    }

    timer = setTimeout(typeEffect, speed);
  }

  typeEffect();

  /* STOP on focus */
  input.addEventListener("focus", () => {
    clearTimeout(timer);
    input.placeholder = "";
  });

  /* RESTART on blur */
  input.addEventListener("blur", () => {
    charIndex = 0;
    isDeleting = false;
    typeEffect();
  });
}

/* START BOTH */
if (headerInput) startTyping(headerInput);
if (overlayInput) startTyping(overlayInput);



// live search
const searchInputLive = document.getElementById("animatedSearch");
const resultsBox = document.getElementById("liveSearchResults");

let debounceTimer;

searchInputLive.addEventListener("input", function () {
  const query = this.value.trim();

  clearTimeout(debounceTimer);

  if (query.length < 1) {
    resultsBox.innerHTML = "";
    return;
  }

  resultsBox.innerHTML = `
    <div class="search-loader">
      <span></span><span></span><span></span>
    </div>
  `;

  debounceTimer = setTimeout(() => {

    fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=5`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;

        let html = "";

        if (products.length === 0) {
          html = `<p class="no-results-msg">No results found</p>`;
        } else {

          products.forEach(product => {
            html += `
             <a href="${product.url.split('?')[0]}" class="live-item">
                <img src="${product.image}" alt="${product.title}">
                <div>
                  <div class="live-item-title">${product.title}</div>
<div class="live-item-price">${formatCurrency(product.price * 100)}</div>
                </div>
              </a>
            `;
          });
          html += `
          <a href="/search?q=${encodeURIComponent(query)}" class="view-all-btn">
            View all results →
          </a>
        `;
        }

        resultsBox.innerHTML = html;
      });

  }, 150);
});


/* CLICK OUTSIDE CLOSE */
document.addEventListener("click", (e) => {
  if (!e.target.closest(".search-box")) {
    resultsBox.innerHTML = "";
  }
});
let wishlist = [];
function updateWishlistCount() {

  document.querySelectorAll(".wishlist-count").forEach(el => {

    if (wishlist.length > 0) {

      el.innerText = wishlist.length;
      el.style.display = "flex";

    } else {

      el.style.display = "none";

    }

  });

}
function createWishlistBurst(el) {
  const rect = el.getBoundingClientRect();

  for (let i = 0; i < 8; i++) {

    const particle = document.createElement('div');
    particle.classList.add('wishlist-particle');

    particle.innerHTML = `
      <svg viewBox="0 0 24 24" width="100%" height="100%">
        <path d="M12 21s-6.7-4.35-9.33-7C-1.33 10.67 1.33 6 5.5 6c2.04 0 3.5 1.2 4.5 2.44C11 7.2 12.46 6 14.5 6 18.67 6 21.33 10.67 21.33 14c-2.63 2.65-9.33 7-9.33 7z" 
        fill="red"/>
      </svg>
    `;

    const angle = Math.random() * 2 * Math.PI;
    const distance = 30; // FIXED (no crazy spread)

    const x = Math.cos(angle) * distance + 'px';
    const y = Math.sin(angle) * distance + 'px';

    particle.style.setProperty('--x', x);
    particle.style.setProperty('--y', y);

    particle.style.left = rect.left + rect.width / 2 + 'px';
    particle.style.top = rect.top + rect.height / 2 + 'px';
    particle.style.transform = 'translate(-50%, -50%)';

    particle.style.width = '12px';
    particle.style.height = '12px';

    document.body.appendChild(particle);
    setTimeout(() => particle.remove(), 700);
  }
}
document.addEventListener("DOMContentLoaded", function () {

  // let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  // let wishlist = [];

  const customerId = window.ShopifyAnalytics?.meta?.page?.customerId || null;


  async function loadWishlist() {
    console.log("loadWishlist called");
    console.log(customerId);
    if (!customerId) {

      wishlist = [];
      updateWishlistCount();
      return;

    }

    try {

      const response = await fetch(
        `https://phpstack-1001567-6525396.cloudwaysapps.com/api/wishlist/fetch.php?customer_id=${customerId}`
      );

      const data = await response.json();

      if (data.success) {

        wishlist = data.products;
        document.querySelectorAll(".wishlist-btn").forEach((btn) => {

          const productId = btn.dataset.id;

          const icon = btn.querySelector("i");

          const exists = wishlist.some(item => item.id == productId);

          if (exists) {

            btn.classList.add("active");

            icon.classList.remove("fa-regular");
            icon.classList.add("fa-solid");

          } else {

            btn.classList.remove("active");

            icon.classList.remove("fa-solid");
            icon.classList.add("fa-regular");

          }

        });
        updateWishlistCount();

        document.dispatchEvent(new CustomEvent("wishlist:loaded"));

      }

    } catch (error) {

      console.error(error);

    }

  }




  // MARK ACTIVE ITEMS
  document.querySelectorAll(".wishlist-btn").forEach(btn => {
    const id = btn.dataset.id;
    const icon = btn.querySelector("i");

    if (wishlist.some(item => item.id === id)) {
      btn.classList.add("active");

      icon.classList.remove("fa-regular");
      icon.classList.add("fa-solid");
    }
  });


  document.querySelectorAll(".wishlist-btn").forEach((btn) => {
    btn.addEventListener("click", async function () {
      const icon = this.querySelector("i");
      const productId = this.dataset.id;

      const product = {
        id: productId,
        variant: this.dataset.variant,
        title: this.dataset.title,
        image: this.dataset.image,
        url: this.dataset.url,
        price: this.dataset.price,
        compare: this.dataset.compare,
      };

      if (!customerId) {
        showToast("Please login to add products to your wishlist ❤️");
        return;
      }

      // ── INSTANT UI UPDATE ──
      const wasActive = this.classList.contains("active");
      const willBeActive = !wasActive;
      const allBtns = document.querySelectorAll(`.wishlist-btn[data-id="${productId}"]`);

      allBtns.forEach((b) => {
        const i = b.querySelector("i");
        b.classList.toggle("active", willBeActive);
        i.classList.toggle("fa-solid", willBeActive);
        i.classList.toggle("fa-regular", !willBeActive);
      });

      if (willBeActive) {
        wishlist.push(product);
      } else {
        wishlist = wishlist.filter((item) => item.id != productId);
      }

      updateWishlistCount();
      createWishlistBurst(this);
      showToast(willBeActive ? "Added to wishlist ❤️" : "Removed from wishlist ❌");

      // ── SYNC TO SERVER IN BACKGROUND ──
      try {
        const formData = new FormData();
        formData.append("customer_id", customerId);
        formData.append("product_id", productId);

        const response = await fetch(
          "https://phpstack-1001567-6525396.cloudwaysapps.com/api/wishlist/toggle.php",
          { method: "POST", body: formData }
        );
        const data = await response.json();

        if (!data.success) throw new Error("toggle failed");
      } catch (error) {
        console.error(error);
        // rollback if server call failed
        allBtns.forEach((b) => {
          const i = b.querySelector("i");
          b.classList.toggle("active", wasActive);
          i.classList.toggle("fa-solid", wasActive);
          i.classList.toggle("fa-regular", !wasActive);
        });
        if (willBeActive) {
          wishlist = wishlist.filter((item) => item.id != productId);
        } else {
          wishlist.push(product);
        }
        updateWishlistCount();
        showToast("Something went wrong, try again");
      }
    });

  });
  window.loadWishlist = loadWishlist;
  loadWishlist();
});
document.addEventListener("DOMContentLoaded", async function () {

  const cards = document.querySelectorAll(".product-rating");

  if (!cards.length) return;

  const ids = [...cards].map(card => card.dataset.productId);

  try {

    const response = await fetch(
      `https://phpstack-1001567-6525396.cloudwaysapps.com/product-ratings.php?product_ids=${ids.join(",")}`
    );

    const data = await response.json();

    if (!data.success) return;

    cards.forEach(card => {

      const id = card.dataset.productId;
      const product = data.products[id];

      // No rating found → hide entire rating div
      if (!product || !product.rating || product.rating <= 0) {
        card.style.display = "none";
        return;
      }

      // Rating exists → show it
      card.style.display = "";

      card.querySelector(".rating-value").textContent =
        `(${product.rating.toFixed(1)})`;

    });

  } catch (e) {

    console.error(e);

  }

});
// run on load

// updateWishlistCount();